// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-aster -> weidner-apartment-homes-aster -> two-zero-six-bell-apartments
// Generated: 2026-10-30T02:11:06.460Z
// Counts: 2 design, 63 content, 25 slot group, 4 collection binding, 8 section, 0 style

export const designOverrides = {
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "VALUE",
    "value": "#707070",
    "mappedField": null
  },
  "design.SpecialOfferBanner.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Accessibility</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_amenities_blurb"
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Amenities</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Amenities</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.intro": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Welcome to a world of unmatched luxury and convenience at <span data-type=\"field-token\" data-field=\"property_name\"></span>. Our amenity offerings redefine the standard of modern living, providing an exquisite backdrop to complement your lifestyle.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiessummary.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiessummary.interiorHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_applynow_blurb"
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Apply Now</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_contactus_blurb"
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Contact Us</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "conveniencecallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "conveniencecallout.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Convenience All Around</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_floorplans_blurb"
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Floor Plans</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.feature_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "floorplanslist.feature_title": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Spacious Apartment Homes</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.contact_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Contact</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.follow_us_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Follow Us</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.office_hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Office Hours</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.visit_us_label": {
    "overrideType": "VALUE",
    "customValue": "<h4>Visit Us</h4>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_gallery_blurb"
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Gallery</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-meridian-id::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Discover dog-friendly apartments in Meridian, Idaho. Enjoy pet-friendly living spaces tailored for you and your furry friends.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/dog-friendly-apartments-meridian-id::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Dog-Friendly Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Interactive Map</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "letsconnect.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Have questions about how to start living at your new home? Our dedicated leasing team at <span data-type=\"field-token\" data-field=\"property_name\"></span> is here to assist you.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "letsconnect.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Let's Connect</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_neighborhood_blurb"
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Neighborhood</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Pet Policy</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyinfo.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "petpolicyinfo.info": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "petpolicyinfo.restrictions": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_restrictions"
  },
  "petpolicyinfo.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Privacy Policy</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_long_description"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Luxury Apartment Living</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_residentaccess_blurb"
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Resident Access</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.help_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Need Help? Call Us</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.portal_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Resident Portal</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Schedule A Tour</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Sitemap</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "testimonials.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Testimonials</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Thank You</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_virtualtours_blurb"
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 40px;\">Virtual Tour</span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "dallasmavericksgames.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Go Mavs, Go <span data-type=\"field-token\" data-field=\"property_name\"></span>!</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "deals-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>CORT Furniture Rental</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "future-residents-club-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Future Residents Club</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "conveniencecallout.background": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "conveniencecallout.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "floorplanslist.feature_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Choose Your Home"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "letsconnect.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "accessibility-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04ab8-faa7-75b5-bcdc-1cec3c17aeb9.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Solid red background."
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[3].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[3].image_media.alt_text"
      }
    }
  },
  "contact-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04ab7-816b-75bb-869e-28d63b4ecdc8.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A person's hand holding a smartphone, showcasing modern technology and connectivity."
      }
    }
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[13].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[13].image_media.alt_text"
      }
    }
  },
  "floorplanslist.feature_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[14].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[14].image_media.alt_text"
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-1f06-75f1-9095-12beec2f93c2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop patio with seating, grills, and a fire pit overlooking the water at sunset."
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04aad-2008-74aa-a4e4-f039b45622d4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with seating, tables, and city views at sunset."
      }
    }
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04abb-1aec-70cf-9fd5-f8d18a3a5265.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cute Shih Tzu dog sitting on a retro red chair, perfect pet photo."
      }
    }
  },
  "photoslider.slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-2406-75ce-a43d-98620f177da0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Stylish living area with a blue sofa and modern kitchen."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Bright Living Space"
      }
    }
  },
  "photoslider.slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-32b3-771e-943f-9c344a809242.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a dishwasher."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Chef-Inspired Kitchen"
      }
    }
  },
  "photoslider.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-4a69-732f-84df-423e0dde54ba.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop deck with seating, dining area, and city views at sunset."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop Deck"
      }
    }
  },
  "photoslider.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-5982-77c8-b768-f0fa09d6ec45.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community lounge with a pool table, foosball table, seating area, and kitchenette."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Lounge & Game Room"
      }
    }
  },
  "photoslider.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-5c12-703f-a3df-d13d1f7e8f53.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fitness center with treadmills, ellipticals, weight machine, and stability balls."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "24-Hour Fitness Center"
      }
    }
  },
  "photoslider.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/019d022d-76cf-720c-8671-82ac95a976cd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment building exterior with colorful facade and large windows."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "206 Bell Exterior"
      }
    }
  },
  "privacy-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04ab8-faa7-75b5-bcdc-1cec3c17aeb9.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright and bold red abstract background, ideal for vibrant designs."
      }
    }
  },
  "qualifying-criteria-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167306/01a04ab8-faa7-75b5-bcdc-1cec3c17aeb9.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Solid red background."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[9].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[9].image_media.alt_text"
      }
    }
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[15].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[15].image_media.alt_text"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "photoslider.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      0,
      1,
      2,
      3,
      7,
      11,
      10,
      9
    ],
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      22,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52
    ],
    "customItems": null
  },
  "amenitieslist.interiorItems": {
    "limit": null,
    "hiddenIds": [
      "ec_38a67fc56b633cbb6bed3ed9",
      "ec_5951e346870f7ddb79931c4f",
      "ec_0fd211050f8a3529a1c6dd5d",
      "ec_92c2b1dda0067c7d9ff891c1",
      "ec_73a6f6c0a19f9fa13cde9e4e",
      "ec_7630adec761903a8c23121dd",
      "ec_12a5355c95a37d15414b4e35",
      "ec_34622a488184ede88b817ee5"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "galleryapartments.communityImages": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_cedbd5ef9b7278c8300cecff",
      "ec_56c8850c51fbe533de462e2a",
      "ec_cf083bec02fbf10259e214ad",
      "ec_123d703dc565c2984b19aba6",
      "ec_a8fe84697d7b5a346eb169a4",
      "ec_578c7facaf38fc732bded88e",
      "ec_0ff01bba75984e8953715d45",
      "ec_b60f8bb4dd87546af2b49201"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": [
      "ec_e991bd7c42d3ef51a6b86352",
      "ec_592af04e781a0b646e52551d",
      "ec_ccd2da22a3995d3daf708f97"
    ],
    "orderedIds": [
      "ec_d1d6016b6055aba8aafade10",
      "ec_f8c68aae087f03335cfc03e3",
      "ec_c62997d460d1f8ad3ee4c415",
      "ec_13edf138e9586f78bf38db62",
      "ec_89ecfea18145f262f3a35182",
      "ec_19561b168ea9ae1fafb70126",
      "ec_ccd2da22a3995d3daf708f97",
      "ec_592af04e781a0b646e52551d",
      "ec_e991bd7c42d3ef51a6b86352"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
